import { ID } from 'api'
import { graphql } from 'msw'
import db from '../db'
import { CategoryFilterMock } from './data'

const categoryFilterHandlers = [
  graphql.query('listCategoryFilters', (req, res, ctx) => {
    const publisherId = req.variables.publisherId as ID

    const categoryFilters = db.categoryFilter.getAll(
      (ctgFilter) => ctgFilter.publisher.id === publisherId
    )
    return res(ctx.data({ categoryFilters }))
  }),

  graphql.query('queryCategoryFilter', (req, res, ctx) => {
    const id = req.variables.id as ID
    const categoryFilter = db.categoryFilter.get(id)
    return res(ctx.data({ categoryFilter }))
  }),

  graphql.mutation('createCategoryFilter', (req, res, ctx) => {
    const variables = req.variables as CategoryFilterMock
    const applications = db.application.getAll((app) =>
      variables.applicationIds.includes(app.id)
    )
    const blockedAdvertisersConnection = db.advertisers.getAll((advertiser) =>
      variables.blockedAdvertisers.includes(advertiser.cmsId)
    )
    const blockedProductsConnection = db.products.getAll((product) =>
      variables.blockedProducts.includes(product.cmsId)
    )
    const categoryFilter = db.categoryFilter.create({
      applications,
      publisher: {
        id: variables.publisherId,
      },
      blockedAdvertisersConnection,
      blockedProductsConnection,
      ...variables,
    })

    return res(ctx.data({ categoryFilter }))
  }),

  graphql.mutation('updateCategoryFilter', (req, res, ctx) => {
    const variables = req.variables as CategoryFilterMock
    const blockedAdvertisersConnection = db.advertisers.getAll((advertiser) =>
      variables.blockedAdvertisers.includes(advertiser.cmsId)
    )
    const blockedProductsConnection = db.products.getAll((product) =>
      variables.blockedProducts.includes(product.cmsId)
    )
    const categoryFilter = db.categoryFilter.update({
      blockedAdvertisersConnection,
      blockedProductsConnection,
      ...variables,
    })

    return res(ctx.data({ categoryFilter }))
  }),

  graphql.mutation('deleteCategoryFilter', (req, res, ctx) => {
    const categoryFilter = db.categoryFilter.remove(req.variables.id)
    return res(ctx.data({ categoryFilterDestroy: { categoryFilter } }))
  }),
]

export default categoryFilterHandlers
